import Swiper from "swiper";
import {Pagination} from "swiper/modules";
import 'swiper/css/bundle';

document.addEventListener('DOMContentLoaded', function () {
    frontpageImageSlider();
});

function frontpageImageSlider() {
    new Swiper('#frontpage-slider .swiper-container', {
        modules: [Pagination], autoHeight: true, loop: true, spaceBetween: 20, pagination: {
            el: '.swiper-pagination', clickable: true,
        }
    });
}
